module.exports = __webpack_public_path__ + "static/rivella_waves_left-9a69e1076f6ac0b06b79c811861431f5.mp4";